export const COOKIE_PROPERTIES_VISITED = 'vpid'
export const PROPERTIES_VISITED_MAX = 8
